// import Vant from 'vant';
// import '@sweet/vant-theme-sweet/dist/index.css';
import Vue from 'vue'
import { Toast, Button, Icon, Col, Row, Popup, Checkbox, CheckboxGroup, Field, Form, RadioGroup, Radio, Search, Switch, Uploader, ActionSheet, Dialog, DropdownMenu, DropdownItem, Loading, PullRefresh, SwipeCell, ShareSheet, Collapse, CollapseItem, List, Popover, Sticky, Tab, Tabs, NavBar, Notify, ImagePreview, Picker } from 'vant';

Vue.use(Toast);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Col);
Vue.use(Row);
Vue.use(Popup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Field);
Vue.use(Form);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Search);
Vue.use(Switch);
Vue.use(Uploader);
Vue.use(ActionSheet);
Vue.use(Dialog);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Loading);
Vue.use(PullRefresh);
Vue.use(SwipeCell);
Vue.use(ShareSheet);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(List);
Vue.use(Popover);
Vue.use(Sticky);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(NavBar);
Vue.use(Notify);
Vue.use(ImagePreview);
Vue.use(Picker);

Vue.prototype.$imagePreview = ImagePreview


// export default Vant;
